/**
 * File hubspot-forms.js.
 *
 * Provides a function to load the Hubspot forms script on-demand.
 */
(function () {
  var portalId = '3434541';
  var scriptSrc = 'https://js.hsforms.net/forms/embed/developer/' + portalId + '.js';
  var scriptId = 'cw-hubspot-forms-loader';
  var scriptSelector = '#' + scriptId + ', script[src="' + scriptSrc + '"]';
  var isLoading = false;

  window.cwLoadHubSpotForms = function () {
    if (isLoading || document.querySelector(scriptSelector)) {
      return;
    }

    isLoading = true;

    var script = document.createElement('script');
    script.id = scriptId;
    script.src = scriptSrc;
    script.defer = true;
    script.onload = function () {
      isLoading = false;
    };
    script.onerror = function () {
      isLoading = false;
    };

    document.head.appendChild(script);
  };
})();
